import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteVendorCreationPopupContent.SubsidiariesInformation',
    {
        subsidiariesSection: 'Subsidiaries',
        primarySubsidiary: 'Primary subsidiary',
        subsidiaries: 'Subsidiaries',
        addLineButtonText: 'Add line',
        selectPlaceholder: 'Select value',
        creditLimit: 'Credit limit',
        taxCode: 'Tax code',
        inputPlaceholder: 'Enter value',
        cloneLine: 'Clone a line',
        removeLine: 'Remove a line',
    }
);
